import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'grid-text-editor',
  template: `
    <label *ngIf="showInput">{{ value }} </label>
    <input
      *ngIf="!showInput"
      #input
      type="text"
      [(ngModel)]="value"
      class="grid-cell-edit-layout"
      [ngClass]="{
        'invalid-text': isRenbanInvalid || isModuleInvalid  
      }"
      (change)="textUpdated()"
      (keypress)="onKeyPress($event)"
      (input)="checkValidity()" 
    />
  `,
  styles: [
    `
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      .grid-cell-edit-layout {
        width: 100%;
        border: 1px solid black;
      }
      .invalid-text {
        border: 2px solid red !important;
      }
    `,
  ],
})
// [ngClass]="{
//   'invalid-text': isRenbanInvalid || isModuleInvalid || isSupplierInvalid || isCommentInvalid
// }"
export class UpdatedPartscountComponent {
  public params: any;
  showInput = true;
  value: any;
  isEmpty = true;

  // Track invalid states for renban_number and module_number
  isRenbanInvalid = false;
  isModuleInvalid = false;
  isSupplierInvalid = false;
  isCommentInvalid = false;
  isCountUpdated = false;
  isApcUpdated = false;
  isModuleUpdated = false;
  // isCommentUpdated = false;
  // isSupplierNumberUpdated = false;
  isRenbanUpdated = false;
  @ViewChild('input') inputRef: ElementRef<HTMLInputElement>;

  focusInput(): void {
    setTimeout(() => this.inputRef?.nativeElement?.focus(), 0);
  }

  constructor() {}
  

  agInit(params: any): void {
    if (params.column === 'count_number') {
      params.data.count_number = this;
      this.value = params.data.orderLot;
      this.isEmpty = this.value <= 0;
    } else if (params.column === 'apc_value') {
      params.data.apc_value = this;
      this.value = params.data.apccapacity;
      this.isEmpty = this.value <= 0;
    } else if (params.column === 'renban_number') {
      //debugger
      params.data.containerRenban = this;
      //this.value = params.data.containerRenban;
      this.value = params.data.renban_number;
      this.isEmpty = !this.value;
    } else if (params.column === 'module_code') {
      params.data.moduleNumber = this;
      this.value = params.data.module_code;
      //this.value = params.data.moduleNumber;
      this.isEmpty = !this.value;
    } 
    // else if (params.column === 'supplier_number') {
    //   params.data.supplier_number = this;
    //   this.value = params.data.supplier_code;
    //   this.isEmpty = !this.value;
    // } 
    // else if (params.column === 'comment_data') {
    //   params.data.comment_data = this;   //change not provided response
    //   this.value = params.data.comment;
    //   this.isEmpty = !this.value;
    // }

    this.params = params;
    this.showInput = !this.params.data.checkedEditMode;
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  textUpdated() {
    const inputValue = this.value?.toString().trim();
    const column = this.params.column;
  
    switch (column) {
      case 'count_number':
        const prevCount = this.params.data.orderLot?.toString();
        if (inputValue !== prevCount) {
          this.params.data.count_number.value = inputValue;
          this.params.data.isCountUpdated = true;
          this.params.data.orderLot = inputValue;
        }
        break;
  
      case 'apc_value':
        const prevApc = this.params.data.apccapacity?.toString();
        if (inputValue !== prevApc) {
          this.params.data.apc_value.value = inputValue;
          this.params.data.isApcUpdated = true;
          this.params.data.apccapacity = inputValue;
        }
        break;
  
      case 'renban_number':
        const prevRenban = this.params.data.containerRenban?.toString();
        if (inputValue !== prevRenban) {
          this.params.data.containerRenban.value = inputValue;
          // this.params.data.renban_number.value = inputValue;
          this.params.data.isRenbanUpdated = true;
          // this.params.data.containerRenban = inputValue;
          this.params.data.renban_number = inputValue;
        }
        break;
  
      case 'module_code':
        const prevModule = this.params.data.moduleNumber?.toString();
        if (inputValue !== prevModule) {
          // this.params.data.module_code.value = inputValue;
          this.params.data.moduleNumber.value = inputValue;
          this.params.data.isModuleUpdated = true;
          //this.params.data.moduleNumber = inputValue;
          this.params.data.module_code = inputValue;
        }
        break;
  
      case 'supplier_number':
        const prevSupplier = this.params.data.supplier_code?.toString();
        if (inputValue !== prevSupplier) {
          this.params.data.supplier_number.value = inputValue;
          this.params.data.isSupplierNumberUpdated = true;
          this.params.data.supplier_code = inputValue;
        }
        break;
  
      case 'comment_data':
        const prevComment = this.params.data.comment?.toString();
        if (inputValue !== prevComment) {
          this.params.data.comment_data.value = inputValue;
          this.params.data.isCommentUpdated = true;
          this.params.data.comment = inputValue;
        }
        break;
    }
  
    this.checkValidity(); // Revalidate input after update
  }

  onKeyPress(event) {
    const column = this.params.column;
    const char = event.key;
    const currentValue = event.target.value;

    if (column === 'count_number') {
      // Allow digits and one decimal point
      if (!/[\d.]/.test(char)) return false;
      if (char === '.' && currentValue.includes('.')) return false;

      const parts = currentValue.split('.');
      if (parts.length === 2 && parts[1].length >= 2) return false; // Max 2 decimal places
      if (currentValue.length >= this.getMaxLength(column)) return false;
    }

    else if (column === 'apc_value') {
      if (event.charCode < 48 || event.charCode > 57) return false;
      if (currentValue.length >= this.getMaxLength(column)) return false;
    }

    else if (column === 'renban_number') {
      if (!/^[a-zA-Z0-9]*$/.test(char)) return false;
      if (currentValue.length >= 5) return false;
    }

    else if (column === 'module_code') {
      if (!/^[a-zA-Z0-9]*$/.test(char)) return false;
      if (currentValue.length >= 4) return false;
    }

    return true;
  }
  getMaxLength(column: string): number {
    if (column === 'count_number') return 8;
    if (column === 'apc_value') return 5;
    // if (column === 'supplier_number') return 7;
    // if (column === 'comment_data') return 250;
    return 0;
  }

  // Check if 'renban_number' is exactly 5 characters and 'module_number' is exactly 4 characters
  checkValidity() {
    // Validate renban_number
    if (this.params.column === 'renban_number') {
      this.isRenbanInvalid = this.value.length !== 5;
    }

    // Validate module_number
    if (this.params.column === 'module_code') {
      this.isModuleInvalid = this.value.length !== 4;
    }

    // Validate supplier_number
    // if (this.params.column === 'supplier_number') {
    //   this.isSupplierInvalid = this.value.length !== 7 || !/^\d{10}$/.test(this.value);  // Only 05 digits allowed
    // }
    // Validate supplier_number
    // if (this.params.column === 'comment_data') {
    //   this.isCommentInvalid = this.value.length !== 50 || !/^\d{10}$/.test(this.value);  // Only 50 digits allowed
    // }
  }
}
